Service = App.loadClass 'core::Angular/Service'

class exports.UploadsService extends Service
    constructor: (@http, @rootScope) ->
        undefined

    getUsers: () =>
        return @http.post 'backend/admin/new-tools/uploads/get-users'

    getFiles: (userId) =>
        return @http.post "backend/admin/new-tools/uploads/#{userId}/get-files"

    deleteFile: (fileId) =>
        return @http.post "backend/admin/new-tools/uploads/#{fileId}/delete-file"
